import { ActionType, createAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { DTO } from './types'

export const updateMessageTextAction = createAction('@chat/UPDATE_MESSAGE_TEXT')<DTO>()

const success = (state: ChatState, action: ActionType<typeof updateMessageTextAction>): ChatState => {
  const activeChatMessages = state.activeChat.messages
  const messageIndex = activeChatMessages.findIndex(message => message.messageId === action.payload.messageId)
  if (messageIndex === -1) return state
  const newMessages = [...activeChatMessages]
  newMessages[messageIndex] = {
    ...newMessages[messageIndex],
    messageText: action.payload.messageText,
    isEdit: true
  }

  return {
    ...state,
    activeChat: { ...state.activeChat, messages: newMessages }
  }
}

export const updateMessageTextHandle = { asyncAction: updateMessageTextAction, success }
